import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AdminFormFactory } from '../../mappers/admin-form.factory';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { AdminService } from '../../services/admin.service';
import { AdminDto } from '../../dtos/admin.dto';
import { ErrorService } from '../../../../core/services/error.service';
import { AdminType } from '../../enums/admin-type.enum';
import { AdminTypePipe } from '../../pipes/admin-type.pipe';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-add-admin',
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInput,
    MatButton,
    AdminTypePipe,
    MatSelectModule,
    TranslocoPipe
  ],
  templateUrl: './add-admin.dialog.html',
  styleUrl: './add-admin.dialog.scss'
})
export class AddAdminDialog implements OnInit {
  adminForm!: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    defaultAdminType: AdminType
  }, private fb: FormBuilder, private translocoService: TranslocoService, private dialogRef: MatDialogRef<AddAdminDialog>, private adminService: AdminService, private errorService: ErrorService) {
  }

  get adminTypes() {
    return [AdminType.admin, AdminType.patientManager];
  }

  ngOnInit() {
    this.adminForm = AdminFormFactory.createAdminForm(this.fb, this.data.defaultAdminType);
  }

  close(): void {
    this.dialogRef.close(false);
  }

  add(): void {
    if (this.adminForm.invalid) {
      this.adminForm.markAllAsTouched();
      return;
    }

    let adminDto: AdminDto = this.adminForm.value;
    this.adminService.registerAdmin(adminDto).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.errorService.handleError(error, this.translocoService.translate("error.title.add_admin"));
      }
    });
  }
}
